<template lang="pug">
  #wt-action-menu
    BDropdown(
      v-if="items"
      aria-role="list"
      :position="position"
      :mobileModal="mobileModal"
    )
      a(slot="trigger" role="button")
        slot(name="trigger")
          BIcon(icon='dots-horizontal')
      BDropdownItem(
        aria-role="listitem"
        :key="'action-item-'+index"
        v-for="(vnode, index) in items"
        :paddingLess="paddingless"
        :hasLink="hasLink"
        :custom="custom"
      )
        vnode(:vnode="vnode")
</template>

<script>
export default {
  name: "WtActionMenu",

  components: {
    vnode: {
      functional: true,
      render: (h, ctx) => ctx.props.vnode
    }
  },

  props: {
    position: {
      type: String,
      default: "is-bottom-left"
    },
    mobileModal: {
      type: Boolean,
      default: true
    },
    paddingless: {
      type: Boolean,
      default: false
    },
    hasLink: {
      type: Boolean,
      default: false
    },
    custom: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    items() {
      return this._.isEmpty(this.$slots.default)
        ? null
        : this.$slots.default.filter(el => el.tag !== undefined);
    }
  }
};
</script>

<style lang="sass" scoped>
#wt-action-menu
  .dropdown-item
    padding-right: .1rem
</style>
